export const CURRENT_DATE = new Date();
export const END_OF_TODAY = new Date();
END_OF_TODAY.setUTCHours(23, 59, 59, 999);
export const MIN_DATE = new Date(CURRENT_DATE.getTime() - 1000 * 60 * 60 * 24 * 28);
export const ONE_WEEK_AGO = new Date(CURRENT_DATE.getTime() - 1000 * 60 * 60 * 24 * 7);
export const TWENTY_EIGHT_DAYS_AGO = new Date(CURRENT_DATE.getTime() - 1000 * 60 * 60 * 24 * 28);
export const START_OF_TODAY = new Date();
START_OF_TODAY.setUTCHours(0, 0, 0, 0);
